import { render, staticRenderFns } from "./MandateLibrary.vue?vue&type=template&id=1a0e2471&scoped=true&"
import script from "./MandateLibrary.vue?vue&type=script&lang=js&"
export * from "./MandateLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e2471",
  null
  
)

export default component.exports